export const mx = {
  sodimac: {
    colorGroupMapping: {},
    textDictionary: {},
    toggles: {},
    endpoints: {
      BASKET_PAGE_URI: 'https://www.sodimac.com.mx/sodimac-mx/basket',
      BASKET_PAGE_URI_SODIMAC: 'https://www.sodimac.com.mx/sodimac-mx/basket',
    },
    facetLabels: {},
    configurations: {},
  },
  so_retail: {
    colorGroupMapping: {},
    textDictionary: {
      SEE_MORE: 'ver más',
      SEE_LESS: 'ver menos',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
    },
    toggles: {},
    endpoints: {
      BASKET_PAGE_URI: 'https://www.sodimac.com.mx/sodimac-mx/basket',
      BASKET_PAGE_URI_SODIMAC: 'https://www.sodimac.com.mx/sodimac-mx/basket',
    },
    facetLabels: {},
    configurations: {},
  },
};
